export default __webpack_public_path__ + "media/images/elephant_ui_plane_sub-7c3c3708a68c837ca5a260004ade326f.png";